import * as color from 'color';

export function fiSetBrandingColor(colorCode, selector?, parent: HTMLElement = document.head): HTMLStyleElement {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(fiBuildColorCss(colorCode, 'branded', selector)));
    parent.appendChild(style);
    return style;
}

export function fiSetContrastColor(colorCode, selector?, parent: HTMLElement = document.head): HTMLStyleElement {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(fiBuildColorCss(colorCode, 'contrast', selector)));
    parent.appendChild(style);
    return style;
}

export function fiSetWidgetColor(colorCode, selector?, parent: HTMLElement = document.head): HTMLStyleElement {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(fiBuildColorCss(colorCode, 'widget', selector)));
    parent.appendChild(style);
    return style;
}

export function fiBuildColorCss(colorCode: string, colorType: string, selector: string = ':root'): string {
    const hexColor = '#' + colorCode,
        colorDef = color.default(hexColor);

    const colorContrast = getTextColor(hexColor);

    const colorBase = hexColor,
        colorLight = colorDef.lighten(0.33).toString(),
        colorLight_0_25 = colorDef.lighten(0.25).toString(),
        colorLight_0_80 = colorDef.lighten(0.8).toString(),
        colorRgba_0_8 = colorDef.fade(0.2).toString(),
        colorRgba_0_7 = colorDef.fade(0.3).toString(),
        colorRgba_0_6 = colorDef.fade(0.4).toString(),
        colorRgba_0_5 = colorDef.fade(0.5).toString(),
        colorRgba_0_3 = colorDef.fade(0.7).toString(),
        colorRgba_0_1 = colorDef.fade(0.9).toString(),
        colorRgba_0_12 = colorDef.fade(0.88).toString(),
        colorRgba_0_03 = colorDef.fade(0.97).toString(),
        colorRgba_0_02 = colorDef.fade(0.98).toString(),
        colorRgba_whiten_0_5 = colorDef.whiten(0.5).rgb().toString();

    return (
        selector +
        ' {' +
        `--${colorType}-color: ` +
        colorBase +
        ';' +
        `--${colorType}-color-contrast: ` +
        colorContrast +
        ';' +
        `--${colorType}-color-light: ` +
        colorLight +
        ';' +
        `--${colorType}-color-light-025: ` +
        colorLight_0_25 +
        ';' +
        `--${colorType}-color-light-080: ` +
        colorLight_0_80 +
        ';' +
        `--${colorType}-background-color: ` +
        colorBase +
        ';' +
        `--${colorType}-border-color: ` +
        colorBase +
        ';' +
        `--${colorType}-border-color-half: ` +
        colorRgba_0_5 +
        ';' +
        `--${colorType}-ripple-checked-color: ` +
        colorRgba_0_12 +
        ';' +
        `--${colorType}-color-08: ` +
        colorRgba_0_8 +
        ';' +
        `--${colorType}-color-07: ` +
        colorRgba_0_7 +
        ';' +
        `--${colorType}-color-06: ` +
        colorRgba_0_6 +
        ';' +
        `--${colorType}-color-05: ` +
        colorRgba_0_5 +
        ';' +
        `--${colorType}-color-03: ` +
        colorRgba_0_3 +
        ';' +
        `--${colorType}-color-01: ` +
        colorRgba_0_1 +
        ';' +
        `--${colorType}-color-003: ` +
        colorRgba_0_03 +
        ';' +
        `--${colorType}-color-002: ` +
        colorRgba_0_02 +
        ';' +
        `--${colorType}-color-whiten-05: ` +
        colorRgba_whiten_0_5 +
        ';' +
        '}'
    );
}

function getRGB(c): number {
    return parseInt(c, 16) || c;
}

function getsRGB(c: string): number {
    return getRGB(c) / 255 <= 0.03928 ? getRGB(c) / 255 / 12.92 : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4);
}

function getLuminance(hexColor: string): number {
    return (
        0.2126 * getsRGB(hexColor.substr(1, 2)) +
        0.7152 * getsRGB(hexColor.substr(3, 2)) +
        0.0722 * getsRGB(hexColor.substr(-2))
    );
}

function getContrast(f: string, b: string): number {
    const L1 = getLuminance(f);
    const L2 = getLuminance(b);
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
}

function getTextColor(bgColor: string) {
    const whiteContrast = getContrast(bgColor, '#ffffff');
    const blackContrast = getContrast(bgColor, '#B9B9B9');

    return whiteContrast > blackContrast ? '#ffffff' : '#444444';
}
